// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/item_events.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Item } from "./item_pb.js";
import { file_inventory_v1_item } from "./item_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/item_events.proto.
 */
export const file_inventory_v1_item_events: GenFile = /*@__PURE__*/
  fileDesc("Ch5pbnZlbnRvcnkvdjEvaXRlbV9ldmVudHMucHJvdG8SDGludmVudG9yeS52MSKtAQoJSXRlbUV2ZW50EjEKB2NyZWF0ZWQYASABKAsyHi5pbnZlbnRvcnkudjEuSXRlbUNyZWF0ZWRFdmVudEgAEjEKB3VwZGF0ZWQYAiABKAsyHi5pbnZlbnRvcnkudjEuSXRlbVVwZGF0ZWRFdmVudEgAEjEKB2RlbGV0ZWQYAyABKAsyHi5pbnZlbnRvcnkudjEuSXRlbURlbGV0ZWRFdmVudEgAQgcKBWV2ZW50IjQKEEl0ZW1DcmVhdGVkRXZlbnQSIAoEaXRlbRgBIAEoCzISLmludmVudG9yeS52MS5JdGVtImcKEEl0ZW1VcGRhdGVkRXZlbnQSKQoNcHJldmlvdXNfaXRlbRgBIAEoCzISLmludmVudG9yeS52MS5JdGVtEigKDHVwZGF0ZWRfaXRlbRgCIAEoCzISLmludmVudG9yeS52MS5JdGVtIjQKEEl0ZW1EZWxldGVkRXZlbnQSIAoEaXRlbRgBIAEoCzISLmludmVudG9yeS52MS5JdGVtQjdaNXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWludmVudG9yeS9hcGkvdjE7aW52ZW50b3J5X3YxYghlZGl0aW9uc3DoBw", [file_inventory_v1_item]);

/**
 * @generated from message inventory.v1.ItemEvent
 */
export type ItemEvent = Message<"inventory.v1.ItemEvent"> & {
  /**
   * @generated from oneof inventory.v1.ItemEvent.event
   */
  event: {
    /**
     * @generated from field: inventory.v1.ItemCreatedEvent created = 1;
     */
    value: ItemCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: inventory.v1.ItemUpdatedEvent updated = 2;
     */
    value: ItemUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: inventory.v1.ItemDeletedEvent deleted = 3;
     */
    value: ItemDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.ItemEvent.
 * Use `create(ItemEventSchema)` to create a new message.
 */
export const ItemEventSchema: GenMessage<ItemEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_events, 0);

/**
 * @generated from message inventory.v1.ItemCreatedEvent
 */
export type ItemCreatedEvent = Message<"inventory.v1.ItemCreatedEvent"> & {
  /**
   * @generated from field: inventory.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message inventory.v1.ItemCreatedEvent.
 * Use `create(ItemCreatedEventSchema)` to create a new message.
 */
export const ItemCreatedEventSchema: GenMessage<ItemCreatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_events, 1);

/**
 * @generated from message inventory.v1.ItemUpdatedEvent
 */
export type ItemUpdatedEvent = Message<"inventory.v1.ItemUpdatedEvent"> & {
  /**
   * @generated from field: inventory.v1.Item previous_item = 1;
   */
  previousItem?: Item;

  /**
   * @generated from field: inventory.v1.Item updated_item = 2;
   */
  updatedItem?: Item;
};

/**
 * Describes the message inventory.v1.ItemUpdatedEvent.
 * Use `create(ItemUpdatedEventSchema)` to create a new message.
 */
export const ItemUpdatedEventSchema: GenMessage<ItemUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_events, 2);

/**
 * @generated from message inventory.v1.ItemDeletedEvent
 */
export type ItemDeletedEvent = Message<"inventory.v1.ItemDeletedEvent"> & {
  /**
   * @generated from field: inventory.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message inventory.v1.ItemDeletedEvent.
 * Use `create(ItemDeletedEventSchema)` to create a new message.
 */
export const ItemDeletedEventSchema: GenMessage<ItemDeletedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_events, 3);

